/**
 * @generated SignedSource<<a23ce9739246112b558eff47f39bef73>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotificationBell_total$data = {
  readonly count: number;
  readonly " $fragmentType": "NotificationBell_total";
};
export type NotificationBell_total$key = {
  readonly " $data"?: NotificationBell_total$data;
  readonly " $fragmentSpreads": FragmentRefs<"NotificationBell_total">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationBell_total",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    }
  ],
  "type": "NotificationUnreadTotal",
  "abstractKey": null
};

(node as any).hash = "20ef1dde6e505f98f0d3c5b727474e84";

export default node;
